import type { SiteConfig } from '../../@types/context/site-config.types';

export const serviceVwoUscoreConfig: Pick<SiteConfig['services'], 'vwo'> = {
  vwo: { id: '1091426' },
};
